import { NgModule } from '@angular/core';
import { RequestClassificationReverseRmkComponent } from './request-classification-reverse-rmk.component';

@NgModule({
	declarations: [],
	imports: [RequestClassificationReverseRmkComponent],
	exports: [RequestClassificationReverseRmkComponent],
})
export class RequestClassificationReverseRmkModule {}
